<template>
  <v-col :cols="cols" :class="colClass">
    <v-slider
      type="range"
      dense
      v-model="internalValue"
      :min="min"
      :max="max"
      :step="step"
      :prepend-icon="prependIcon"
    />
  </v-col>
</template>

<script>
export default {
  name: "CustomSlider",
  props: {
    value: { required: true },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    step: { type: Number, default: 1 },
    prependIcon: { type: String, default: "" },
    cols: { type: [Number, String], default: 9 },
    colClass: { type: String, default: "d-flex justify-center align-center" }
  },
  computed: {
    internalValue: {
      get() { return this.value },
      set(v) { this.$emit('input', v); this.$emit('update:value', v) }
    }
  }
}
</script>